// src/Pages/NotFound.js
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[60vh] bg-slate-900 text-slate-100 flex flex-col items-center justify-center px-6">
      <h1 className="text-5xl font-extrabold mb-4">404</h1>
      <p className="text-slate-300 mb-6">The page you were looking for could not be found.</p>
      <Link to="/" className="bg-cyan-700 hover:bg-cyan-600 transition-colors rounded-lg px-4 py-2 font-semibold">
        Go Home
      </Link>
    </div>
  );
}
